module.exports = __webpack_public_path__ + "files/ba0a5f44a44aa70af15ca246d8f1f293.png";